import { render, staticRenderFns } from "./IconElementPublish.vue?vue&type=template&id=e12c59e2&scoped=true&"
import script from "./IconElementPublish.vue?vue&type=script&lang=ts&"
export * from "./IconElementPublish.vue?vue&type=script&lang=ts&"
import style0 from "./IconElementPublish.vue?vue&type=style&index=0&id=e12c59e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12c59e2",
  null
  
)

export default component.exports